import { render } from "./DeactivateAccount.vue?vue&type=template&id=5c93ca8e&scoped=true"
import script from "./DeactivateAccount.vue?vue&type=script&lang=js"
export * from "./DeactivateAccount.vue?vue&type=script&lang=js"

import "./DeactivateAccount.vue?vue&type=style&index=0&id=5c93ca8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c93ca8e"]])

export default __exports__